import React from 'react';
import Icon from '../../../components/AppIcon';

const LogsStats = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Access Attempts',
      value: stats?.totalAttempts,
      icon: 'Activity',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/20'
    },
    {
      title: 'Successful Access',
      value: stats?.successfulAttempts,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20'
    },
    {
      title: 'Failed Attempts',
      value: stats?.failedAttempts,
      icon: 'XCircle',
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20'
    },
    {
      title: 'Security Anomalies',
      value: stats?.anomalies,
      icon: 'AlertTriangle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
      pulse: stats?.anomalies > 0
    }
  ];

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US')?.format(num);
  };

  const getSuccessRate = () => {
    if (stats?.totalAttempts === 0) return 0;
    return Math.round((stats?.successfulAttempts / stats?.totalAttempts) * 100);
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className={`
            bg-card border ${stat?.borderColor} rounded-lg p-4 security-shadow-card
            ${stat?.pulse ? 'security-pulse' : ''}
          `}
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{stat?.title}</p>
              <p className={`text-2xl font-bold ${stat?.color}`}>
                {formatNumber(stat?.value)}
              </p>
              {stat?.title === 'Successful Access' && (
                <p className="text-xs text-muted-foreground mt-1">
                  {getSuccessRate()}% success rate
                </p>
              )}
            </div>
            <div className={`${stat?.bgColor} p-3 rounded-lg`}>
              <Icon 
                name={stat?.icon} 
                size={24} 
                className={stat?.color}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LogsStats;